import { useEffect, useState } from 'react';
import './DraftSummary.css';
import summaryData from '../../Summary/Data.json';
import { useNavigate, useParams } from 'react-router-dom';
import { axiosInstance } from '../../../axios';
import AudioDiarizationComponent from './AudioDiarizationComponent';

function DraftSummary({ showSuccess, showError, showWarning }) {
    let { id } = useParams();
    const [transcriptSegments, setTranscriptSegments] = useState([]);
    const [audioProcessed, setAudioProcessed] = useState(false);

    console.log(id);
    const [loading, setLoading] = useState(false);
    const [textGeneration, setTextGeneration] = useState(false);
    const [summaryData, setSummaryDataFetch] = useState(null);
    const [type, setType] = useState(null);
    const navigate = useNavigate();


    // Fetch Data
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(`audio_diarization/${id}/`);
            // console.log(response?.status);
            if (response?.status === 200) {
                setLoading(false);
                setSummaryDataFetch(response?.data);
                setTextGeneration(response?.data.loading);
                console.log(textGeneration);
                // Handle successful response, e.g., set some state.
            } else if (response?.data?.detail == 'Unauthenticated!') {
                setLoading(false);
                navigate('/auth/login'); // Use navigate to redirect to the login page.
            } else if (response?.data?.detail == "Audio diarization not found"){
                navigate('/404')
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            setTextGeneration(true)
            console.log(textGeneration);
            showError('데이터 업로드 실패했습니다! 네트워크 상태를 확인해주세요.')
            // TODO: handle errors
        }


    };

    // useEffect(() => {
    //     fetchData();

    // }, []);

    const activeNavTab = 0;
    const [navTable, setNavTable] = useState(activeNavTab);

    const currentSummary = 0;
    const setActiveTab = (index) => {
        setNavTable(index);
    };

    return (
        <>
            <AudioDiarizationComponent setActiveTab={setActiveTab} navTable={navTable} loading={textGeneration} id={id} showWarning={showWarning} />

        </>
    )
}

export default DraftSummary;